module.exports = __webpack_public_path__ + "public/adminIcons/Totalusers.svg?c7a880a4";


//////////////////
// WEBPACK FOOTER
// ./public/adminIcons/Totalusers.svg
// module id = 3064
// module chunks = 8